import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CategoryListingModel, CategoryResponseModel } from 'src/app/models/category/categoryListing.modal';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { CategoryService } from 'src/app/services/category.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { UpdateCategoryComponent } from '../update-category/update-category.component';

@Component({
  selector: 'app-category-listing',
  templateUrl: './category-listing.component.html',
  styleUrls: ['./category-listing.component.css']
})
export class CategoryListingComponent implements OnInit {
  categorylisting: CategoryListingModel;
  categoryResonse: CategoryResponseModel;
  pagingModel: PagingModel;
  categorylist: any;
  Loader: boolean = false;
  totalPages: number;
  pageNumber: number = 1;
  searchValue: string = "";

  constructor(private localstorage: LocalstorageService, private _categoryService: CategoryService, config: NgbModalConfig, private modalService: NgbModal) {
    this.localstorage.setMenu("4");
    this.categorylisting = new CategoryListingModel();
    this.pagingModel = new PagingModel();
    this.categoryResonse = new CategoryResponseModel();
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
  }

  ngOnInit() {
    this.categotyListing();
  }

  resetFilter() {
    this.searchValue = "";
    this.categorylisting.PageNumber = 1;
    this.categorylisting.PageSize = 10;
    this.totalPages = 1;
    this.pageNumber = 1;
    this.categotyListing();
  }

  filter() {
    this.categorylisting.KeyWord = this.searchValue;
    this.categorylisting.PageNumber = 1;
    this.categorylisting.PageSize = 10;
    this.categotyListing();
  }

  categotyListing() {
    this.Loader = true;
    this.categorylisting.KeyWord = this.searchValue;
    this._categoryService.categorylisting(this.categorylisting).subscribe(response => {
      this.categorylist = JSON.parse(response._body);
      if (this.categorylist.isSuccess) {
        this.Loader = false;
        this.categoryResonse.CategoryList = this.categorylist.responseData;
        this.categoryResonse.TotalPages = this.categorylist.totalPages;
        this.totalPages = this.categoryResonse.TotalPages == undefined ? 0 : this.categoryResonse.TotalPages;
      } (err) => {
        this.Loader = false;
      }
    });
  }

  loadPage(pagingModel: PagingModel) {
    this.categorylisting.PageNumber = pagingModel.pageNumber;
    this.categorylisting.PageSize = pagingModel.pageSize;
    this.categotyListing();
  }

  manageCategorydetails(categoryDetail) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "xl";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this._categoryService.passCategoryId(categoryDetail.id);
    let modalRef = this.modalService.open(UpdateCategoryComponent, modalConfig);
    modalRef.result.then(() => {
    }, (reason) => {
      this.categotyListing();
    });
  }
}
